export const setLeads = ({ commit }, payload) => {
  commit('SET_LEADS', payload)
}
export const addLeads = ({ commit }, payload) => {
  commit('ADD_LEADS', payload)
}
export const setLeadsLoading = ({ commit }, payload) => {
  commit('SET_LEADS_LOADING', payload)
}
export const updateLeadLocalData = ({ commit }, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }

  if (payload.incrementComments) {
    commit('INCREMENT_LEAD_COMMENTS_COUNT', payload)
  }

  if (payload.setTaskDone) {
    commit('SET_LEAD_TASK_DONE', payload)
  }

  if (payload.setTaskUndone) {
    commit('SET_LEAD_TASK_UNDONE', payload)
  }
}
export const setLeadsTags = ({ commit }, payload) => {
  commit('SET_LEADS_TAGS', payload)
}

export const addLeadToKanban = ({ commit }, payload) => {
  commit('ADD_LEAD_TO_KANBAN', payload)
}
export const moveLeadInKanban = ({ commit }, payload) => {
  commit('MOVE_LEAD_IN_KANBAN', payload)
}
export const patchLeadInKanban = ({ commit }, payload) => {
  commit('PATCH_LEAD_IN_KANBAN', payload)
}
export const setLeadStatusInKanban = ({ commit }, payload) => {
  commit('SET_LEAD_STATUS_IN_KANBAN', payload)
}

export const setMonthlyRoutine = ({ commit }, payload) => {
  commit('SET_MONTHLY_ROUTINE', payload)
}
export const addMonthlyRoutine = ({ commit }, payload) => {
  commit('ADD_MONTHLY_ROUTINE', payload)
}
export const setMonthlyRoutineLoading = ({ commit }, payload) => {
  commit('SET_MONTHLY_ROUTINE_LOADING', payload)
}

export const setFilterLeads = ({ commit }, payload) => {
  commit('SET_FILTER_LEADS', payload)
}

export const setLigacoes = ({ commit }, payload) => {
  commit('SET_LIGACOES', payload)
}
export const addLigacoes = ({ commit }, payload) => {
  commit('ADD_LIGACOES', payload)
}
export const setLigacoesLoading = ({ commit }, payload) => {
  commit('SET_LIGACOES_LOADING', payload)
}
export const setFilterLigacoes = ({ commit }, payload) => {
  commit('SET_FILTER_LIGACOES', payload)
}

export const setSelectedFunilId = ({ commit }, payload) => {
  commit('SET_SELECTED_FUNIL_ID', payload)
}

export const setReguaCliente = ({ commit }, payload) => {
  commit('SET_REGUA_CLIENTE', payload)
}
export const addReguaCliente = ({ commit }, payload) => {
  commit('ADD_REGUA_CLIENTE', payload)
}
export const setReguaClienteLoading = ({ commit }, payload) => {
  commit('SET_REGUA_CLIENTE_LOADING', payload)
}

export const setReguaRelacionamento = ({ commit }, payload) => {
  commit('SET_REGUA_RELACIONAMENTO', payload)
}
export const addReguaRelacionamento = ({ commit }, payload) => {
  commit('ADD_REGUA_RELACIONAMENTO', payload)
}
export const setReguaRelacionamentoLoading = ({ commit }, payload) => {
  commit('SET_REGUA_RELACIONAMENTO_LOADING', payload)
}

export const setAtividadesRegua = ({ commit }, payload) => {
  commit('SET_ATIVIDADES_REGUA', payload)
}
export const addAtividadesRegua = ({ commit }, payload) => {
  commit('ADD_ATIVIDADES_REGUA', payload)
}
export const setAtividadesReguaLoading = ({ commit }, payload) => {
  commit('SET_ATIVIDADES_REGUA_LOADING', payload)
}
export const removeAtividadesRegua = ({ commit }, payload) => {
  commit('REMOVE_ATIVIDADES_REGUA', payload)
}
export const setHistoricoAtividade = ({ commit }, payload) => {
  commit('SET_HISTORICO_ATIVIDADE', payload)
}
export const addHistoricoAtividade = ({ commit }, payload) => {
  commit('ADD_HISTORICO_ATIVIDADE', payload)
}
export const setHistoricoAtividadeLoading = ({ commit }, payload) => {
  commit('SET_HISTORICO_ATIVIDADE_LOADING', payload)
}

export const setAtividadesSugeridas = ({ commit }, payload) => {
  commit('SET_ATIVIDADES_SUGERIDAS', payload)
}
export const addAtividadesSugeridas = ({ commit }, payload) => {
  commit('ADD_ATIVIDADES_SUGERIDAS', payload)
}
export const setAtividadesSugeridasLoading = ({ commit }, payload) => {
  commit('SET_ATIVIDADES_SUGERIDAS_LOADING', payload)
}

export const setEmpresas = ({ commit }, payload) => {
  commit('SET_EMPRESAS', payload)
}
export const addEmpresas = ({ commit }, payload) => {
  commit('ADD_EMPRESAS', payload)
}
export const setEmpresasLoading = ({ commit }, payload) => {
  commit('SET_EMPRESAS_LOADING', payload)
}

export const setGruposFamiliares = ({ commit }, payload) => {
  commit('SET_GRUPOS_FAMILIARES', payload)
}
export const addGruposFamiliares = ({ commit }, payload) => {
  commit('ADD_GRUPOS_FAMILIARES', payload)
}
export const setGruposFamiliaresLoading = ({ commit }, payload) => {
  commit('SET_GRUPOS_FAMILIARES_LOADING', payload)
}
export const setGruposFamiliaresListagem = ({ commit }, payload) => {
  commit('SET_GRUPOS_FAMILIARES_LISTAGEM', payload)
}
export const setGruposFamiliaresListagemLoading = ({ commit }, payload) => {
  commit('SET_GRUPOS_FAMILIARES_LISTAGEM_LOADING', payload)
}

export const setFunil = ({ commit }, payload) => {
  commit('SET_FUNIL', payload)
}
export const addFunil = ({ commit }, payload) => {
  commit('ADD_FUNIL', payload)
}
export const setFunilLoading = ({ commit }, payload) => {
  commit('SET_FUNIL_LOADING', payload)
}
export const setFunilCustomizeLoading = ({ commit }, payload) => {
  commit('SET_FUNIL_CUSTOMIZE_LOADING', payload)
}

export const setFunilSteps = ({ commit }, payload) => {
  commit('SET_FUNIL_STEPS', payload)
}
export const addFunilSteps = ({ commit }, payload) => {
  commit('ADD_FUNIL_STEPS', payload)
}
export const setFunilStepsLoading = ({ commit }, payload) => {
  commit('SET_FUNIL_STEPS_LOADING', payload)
}
export const removeFunilStepsConfig = ({ commit }, payload) => {
  commit('REMOVE_FUNIL_STEPS_CONFIG', payload)
}

export const setFunilStepsTasks = ({ commit }, payload) => {
  commit('SET_FUNIL_STEPS_TASKS', payload)
}
export const addFunilStepsTasks = ({ commit }, payload) => {
  commit('ADD_FUNIL_STEPS_TASKS', payload)
}
export const setFunilStepsTasksLoading = ({ commit }, payload) => {
  commit('SET_FUNIL_STEPS_TASKS_LOADING', payload)
}
export const removeFunilStepsTasks = ({ commit }, payload) => {
  commit('REMOVE_FUNIL_STEPS_TASKS', payload)
}

// ----- Funil de oportunidades: setters (commit via dispatch) ----- //
export const setOportunidadeFunil = ({ commit }, payload) => {
  commit('SET_OPORTUNIDADE_FUNIL', payload)
}
export const addOportunidadeFunil = ({ commit }, payload) => {
  commit('ADD_OPORTUNIDADE_FUNIL', payload)
}
export const setOportunidadeFunilLoading = ({ commit }, payload) => {
  commit('SET_OPORTUNIDADE_FUNIL_LOADING', payload)
}

export const setOportunidadeFunilEtapas = ({ commit }, payload) => {
  commit('SET_OPORTUNIDADE_FUNIL_ETAPAS', payload)
}
export const setOportunidadeFunilEtapasLoading = ({ commit }, payload) => {
  commit('SET_OPORTUNIDADE_FUNIL_ETAPAS_LOADING', payload)
}

export const setOportunidadeFunilAtividades = ({ commit }, payload) => {
  commit('SET_OPORTUNIDADE_FUNIL_ATIVIDADES', payload)
}
export const setOportunidadeFunilAtividadesLoading = ({ commit }, payload) => {
  commit('SET_OPORTUNIDADE_FUNIL_ATIVIDADES_LOADING', payload)
}

export const setOportunidadeFunilCompleto = ({ commit }, payload) => {
  commit('SET_OPORTUNIDADE_FUNIL_COMPLETO', payload)
}
export const setOportunidadeFunilCompletoLoading = ({ commit }, payload) => {
  commit('SET_OPORTUNIDADE_FUNIL_COMPLETO_LOADING', payload)
}
export const moveOportunidadeInKanban = ({ commit }, payload) => {
  commit('MOVE_OPORTUNIDADE_IN_KANBAN', payload)
}
export const setOportunidadeDesfechoInKanban = ({ commit }, payload) => {
  commit('SET_OPORTUNIDADE_DESFECHO_IN_KANBAN', payload)
}
export const upsertOportunidadeInKanban = ({ commit }, payload) => {
  commit('UPSERT_OPORTUNIDADE_IN_KANBAN', payload)
}

export const setOportunidadeMotivosPerda = ({ commit }, payload) => {
  commit('SET_OPORTUNIDADE_MOTIVOS_PERDA', payload)
}
export const setOportunidadeMotivosPerdaLoading = ({ commit }, payload) => {
  commit('SET_OPORTUNIDADE_MOTIVOS_PERDA_LOADING', payload)
}

export const setOrigens = ({ commit }, payload) => {
  commit('SET_ORIGENS', payload)
}
export const addOrigem = ({ commit }, payload) => {
  commit('ADD_ORIGEM', payload)
}
export const setOrigensLoading = ({ commit }, payload) => {
  commit('SET_ORIGENS_LOADING', payload)
}
export const removeOrigem = ({ commit }, payload) => {
  commit('REMOVE_ORIGEM', payload)
}

export const setClients = ({ commit }, payload) => {
  commit('SET_CLIENTS', payload)
}
export const setClientsSummary = ({ commit }, payload) => {
  commit('SET_CLIENTS_SUMMARY', payload)
}
export const setClientsTags = ({ commit }, payload) => {
  commit('SET_CLIENTS_TAGS', payload)
}
export const addClients = ({ commit }, payload) => {
  commit('ADD_CLIENTS', payload)
}
export const setClientsLoading = ({ commit }, payload) => {
  commit('SET_CLIENTS_LOADING', payload)
}

export const setClientsTasks = ({ commit }, payload) => {
  commit('SET_CLIENTS_TASKS', payload)
}
export const setClientsTasksSummary = ({ commit }, payload) => {
  commit('SET_CLIENTS_TASKS_SUMMARY', payload)
}
export const setClientsTasksTags = ({ commit }, payload) => {
  commit('SET_CLIENTS_TASKS_TAGS', payload)
}
export const addClientsTasks = ({ commit }, payload) => {
  commit('ADD_CLIENTS_TASKS', payload)
}
export const setClientsTasksLoading = ({ commit }, payload) => {
  commit('SET_CLIENTS_TASKS_LOADING', payload)
}
export const setClientsTasksLoadingNoSave = ({ commit }, payload) => {
  commit('SET_CLIENTS_TASKS_LOADING_NO_SAVE', payload)
}

export const setRelationshipFilters = ({ commit }, payload) => {
  commit('SET_RELATIONSHIP_FILTERS', payload)
}
export const setLeadTimeline = ({ commit }, payload) => {
  commit('SET_LEAD_TIMELINE', payload)
}
export const addLeadTimeline = ({ commit }, payload) => {
  commit('ADD_LEAD_TIMELINE', payload)
}
export const setLeadTimelineLoading = ({ commit }, payload) => {
  commit('SET_LEAD_TIMELINE_LOADING', payload)
}

export const setKYC = ({ commit }, payload) => {
  commit('SET_K_Y_C', payload)
}
export const addKYC = ({ commit }, payload) => {
  commit('ADD_K_Y_C', payload)
}
export const setKYCLoading = ({ commit }, payload) => {
  commit('SET_K_Y_C_LOADING', payload)
}
export const setKYCList = ({ commit }, payload) => {
  commit('SET_K_Y_C_LIST', payload)
}
export const setKYCListLoading = ({ commit }, payload) => {
  commit('SET_K_Y_C_LIST_LOADING', payload)
}

export const setHistoricoLead = ({ commit }, payload) => {
  commit('SET_HISTORICO_LEAD', payload)
}
export const addHistoricoLead = ({ commit }, payload) => {
  commit('ADD_HISTORICO_LEAD', payload)
}
export const setHistoricoLeadLoading = ({ commit }, payload) => {
  commit('SET_HISTORICO_LEAD_LOADING', payload)
}
export const setTimelineClient = ({ commit }, payload) => {
  commit('SET_TIMELINE_CLIENT', payload)
}
export const addTimelineClient = ({ commit }, payload) => {
  commit('ADD_TIMELINE_CLIENT', payload)
}
export const setTimelineClientLoading = ({ commit }, payload) => {
  commit('SET_TIMELINE_CLIENT_LOADING', payload)
}
export const setCrmIntegrationEmail = ({ commit }, payload) => {
  commit('SET_CRM_INTEGRATION_EMAIL', payload)
}
export const addCrmIntegrationEmail = ({ commit }, payload) => {
  commit('ADD_CRM_INTEGRATION_EMAIL', payload)
}
export const setCrmIntegrationEmailLoading = ({ commit }, payload) => {
  commit('SET_CRM_INTEGRATION_EMAIL_LOADING', payload)
}
export const setCrmIntegrationProviders = ({ commit }, payload) => {
  commit('SET_CRM_INTEGRATION_PROVIDERS', payload)
}

export const setOverviewIndicators = ({ commit }, payload) => {
  commit('SET_OVERVIEW_INDICATORS', payload)
}
export const addOverviewIndicators = ({ commit }, payload) => {
  commit('ADD_OVERVIEW_INDICATORS', payload)
}
export const setOverviewIndicatorsLoading = ({ commit }, payload) => {
  commit('SET_OVERVIEW_INDICATORS_LOADING', payload)
}
export const setFunilStepsConfig = ({ commit }, payload) => {
  commit('SET_FUNIL_STEPS_CONFIG', payload)
}
export const addFunilStepsConfig = ({ commit }, payload) => {
  commit('ADD_FUNIL_STEPS_CONFIG', payload)
}
export const setFunilStepsConfigLoading = ({ commit }, payload) => {
  commit('SET_FUNIL_STEPS_CONFIG_LOADING', payload)
}

export const setRelationshipKanban = ({ commit }, payload) => {
  commit('SET_RELATIONSHIP_KANBAN', payload)
}
export const addRelationshipKanban = ({ commit }, payload) => {
  commit('ADD_RELATIONSHIP_KANBAN', payload)
}
export const setRelationshipKanbanLoading = ({ commit }, payload) => {
  commit('SET_RELATIONSHIP_KANBAN_LOADING', payload)
}

export const setOpportunitiesKanban = ({ commit }, payload) => {
  commit('SET_OPPORTUNITIES_KANBAN', payload)
}
export const setOpportunitiesKanbanLoading = ({ commit }, payload) => {
  commit('SET_OPPORTUNITIES_KANBAN_LOADING', payload)
}
export const addOpportunitiesKanban = ({ commit }, payload) => {
  commit('ADD_OPPORTUNITIES_KANBAN', payload)
}
export const removeOpportunitiesKanban = ({ commit }, payload) => {
  commit('REMOVE_OPPORTUNITIES_KANBAN', payload)
}
export const updateOpportunityKanbanFase = ({ commit }, payload) => {
  commit('UPDATE_OPPORTUNITY_KANBAN_FASE', payload)
}
export const updateLeadStatusInOpportunitiesKanban = ({ commit }, payload) => {
  commit('UPDATE_LEAD_STATUS_IN_OPPORTUNITIES_KANBAN', payload)
}
export const patchClienteInOpportunitiesKanban = ({ commit }, payload) => {
  commit('PATCH_CLIENTE_IN_OPPORTUNITIES_KANBAN', payload)
}

export const setCalendar = ({ commit }, payload) => {
  commit('SET_CALENDAR', payload)
}
export const addCalendar = ({ commit }, payload) => {
  commit('ADD_CALENDAR', payload)
}
export const setCalendarLoading = ({ commit }, payload) => {
  commit('SET_CALENDAR_LOADING', payload)
}

export const setFilterCalendar = ({ commit }, payload) => {
  commit('SET_FILTER_CALENDAR', payload)
}

export const updateCalendarGoogleEvents = ({ commit }, payload) => {
  commit('UPDATE_CALENDAR_GOOGLE_EVENTS', payload)
}

export const updateCalendarExternalEvents = ({ commit }, payload) => {
  commit('UPDATE_CALENDAR_EXTERNAL_EVENTS', payload)
}

export const setCalendarGoogleAgenda = ({ commit }, payload) => {
  commit('SET_CALENDAR_GOOGLE_AGENDA', payload)
}

export const setCalendarMicrosoftAgenda = ({ commit }, payload) => {
  commit('SET_CALENDAR_MICROSOFT_AGENDA', payload)
}

export const addSingleGoogleEvent = ({ commit }, payload) => {
  commit('ADD_SINGLE_GOOGLE_EVENT', payload)
}

export const mergeCalendarMonth = ({ commit }, payload) => {
  commit('MERGE_CALENDAR_MONTH', payload)
}

export const addLoadedMonth = ({ commit }, monthKey) => {
  commit('ADD_LOADED_MONTH', monthKey)
}

export const setCalendarLoadingMonth = ({ commit }, payload) => {
  commit('SET_CALENDAR_LOADING_MONTH', payload)
}

export const removeGoogleEvent = ({ commit }, idEventoProvedor) => {
  commit('REMOVE_GOOGLE_EVENT', idEventoProvedor)
}

export const updateGoogleEvent = ({ commit }, payload) => {
  commit('UPDATE_GOOGLE_EVENT', payload)
}

export const updateActivityTime = ({ commit }, payload) => {
  commit('UPDATE_ACTIVITY_TIME', payload)
}

export const updateActivityDate = ({ commit }, payload) => {
  commit('UPDATE_ACTIVITY_DATE', payload)
}

export const setObservacaoClient = ({ commit }, payload) => {
  commit('SET_OBSERVACAO_CLIENT', payload)
}
export const setObservacaoClientLoading = ({ commit }, payload) => {
  commit('SET_OBSERVACAO_CLIENT_LOADING', payload)
}
export const invalidateObservacaoClient = ({ commit }, idClienteApp) => {
  commit('INVALIDATE_OBSERVACAO_CLIENT', idClienteApp)
}

export const setClienteLeadStatus = ({ commit }, payload) => {
  commit('SET_CLIENTE_LEAD_STATUS', payload)
}
export const setClienteLeadStatusLoading = ({ commit }, payload) => {
  commit('SET_CLIENTE_LEAD_STATUS_LOADING', payload)
}

export const setCrmEmails = ({ commit }, payload) => {
  commit('SET_CRM_EMAILS', payload)
}
export const setCrmEmailsLoading = ({ commit }, payload) => {
  commit('SET_CRM_EMAILS_LOADING', payload)
}
export const setCrmEmailsContadores = ({ commit }, payload) => {
  commit('SET_CRM_EMAILS_CONTADORES', payload)
}
export const setCrmEmailsPagination = ({ commit }, payload) => {
  commit('SET_CRM_EMAILS_PAGINATION', payload)
}
export const setCrmEmailsFolder = ({ commit }, payload) => {
  commit('SET_CRM_EMAILS_FOLDER', payload)
}
export const setCrmEmailsClient = ({ commit }, payload) => {
  commit('SET_CRM_EMAILS_CLIENT', payload)
}
export const addCrmEmail = ({ commit }, payload) => {
  commit('ADD_CRM_EMAIL', payload)
}
export const removeCrmEmail = ({ commit }, payload) => {
  commit('REMOVE_CRM_EMAIL', payload)
}
export const removeCrmEmails = ({ commit }, payload) => {
  commit('REMOVE_CRM_EMAILS', payload)
}
export const clearCrmEmailsScope = ({ commit }, payload) => {
  commit('CLEAR_CRM_EMAILS_SCOPE', payload)
}
export const markCrmEmailRead = ({ commit }, payload) => {
  commit('MARK_CRM_EMAIL_READ', payload)
}
export const markCrmEmailsRead = ({ commit }, payload) => {
  commit('MARK_CRM_EMAILS_READ', payload)
}
export const adjustCrmEmailsContadores = ({ commit }, payload) => {
  commit('ADJUST_CRM_EMAILS_CONTADORES', payload)
}
export const setCrmEmailsFirstAutoSyncDone = ({ commit }, payload) => {
  commit('SET_CRM_EMAILS_FIRST_AUTO_SYNC_DONE', payload)
}

export const setCustomFields = ({ commit }, payload) => {
  commit('SET_CUSTOM_FIELDS', payload)
}
export const setCustomFieldsLoading = ({ commit }, payload) => {
  commit('SET_CUSTOM_FIELDS_LOADING', payload)
}
export const resetCustomFields = ({ commit }) => {
  commit('RESET_CUSTOM_FIELDS')
}

export const setFichaSchema = ({ commit }, payload) => {
  commit('SET_FICHA_SCHEMA', payload)
}
export const setFichaSchemaLoading = ({ commit }, payload) => {
  commit('SET_FICHA_SCHEMA_LOADING', payload)
}

export const setSummaryLayout = ({ commit }, payload) => {
  commit('SET_SUMMARY_LAYOUT', payload)
}
export const setSummaryCatalog = ({ commit }, payload) => {
  commit('SET_SUMMARY_CATALOG', payload)
}
export const setSummaryData = ({ commit }, payload) => {
  commit('SET_SUMMARY_DATA', payload)
}
export const patchSummaryField = ({ commit }, payload) => {
  commit('PATCH_SUMMARY_FIELD', payload)
}
export const clearSummaryData = ({ commit }, payload) => {
  commit('CLEAR_SUMMARY_DATA', payload)
}
export const clearAllSummaryData = ({ commit }) => {
  commit('CLEAR_ALL_SUMMARY_DATA')
}

export const setOverviewLayout = ({ commit }, payload) => {
  commit('SET_OVERVIEW_LAYOUT', payload)
}
export const setOverviewCatalog = ({ commit }, payload) => {
  commit('SET_OVERVIEW_CATALOG', payload)
}

export const patchClientInRelationship = ({ commit }, payload) => {
  commit('PATCH_CLIENT_IN_RELATIONSHIP', payload)
}
export const upsertClientInRelationshipFromResponse = ({ commit }, payload) => {
  commit('UPSERT_CLIENT_IN_RELATIONSHIP_FROM_RESPONSE', payload)
}
export const upsertClientTasksInRelationshipFromResponse = (
  { commit },
  payload
) => {
  commit('UPSERT_CLIENT_TASKS_IN_RELATIONSHIP_FROM_RESPONSE', payload)
}
export const upsertClientKanbanInRelationshipFromResponse = (
  { commit },
  payload
) => {
  commit('UPSERT_CLIENT_KANBAN_IN_RELATIONSHIP_FROM_RESPONSE', payload)
}
export const recomputeRelationshipSummary = ({ commit }) => {
  commit('RECOMPUTE_RELATIONSHIP_SUMMARY')
}

// Setters de Projetos comitados pela API. A própria apiCrmTranscricaoProjetos
// (carregar/salvar/remover) faz fetch+cache+dispatch; o componente chama a API
// direto e lê pelos getters transcriptProjects/transcriptProjectsLoading.
export const setTranscriptProjects = ({ commit }, projects) => {
  commit('SET_TRANSCRIPT_PROJECTS', projects)
}
export const setTranscriptProjectsLoading = ({ commit }, loading) => {
  commit('SET_TRANSCRIPT_PROJECTS_LOADING', loading)
}

// Setters de Scores comitados pela API. apiCrmTranscricoes.carregarScores faz
// fetch+indexação por id+dispatch; o modal chama a API direto e lê pelo getter
// transcriptScores(id).
export const setTranscriptScores = ({ commit }, payload) => {
  commit('SET_TRANSCRIPT_SCORES', payload)
}
export const setTranscriptScoresLoading = ({ commit }, payload) => {
  commit('SET_TRANSCRIPT_SCORES_LOADING', payload)
}
